import Box from '@mui/material/Box';

import { SPECIFIC_PARTNER_BG_BANNER } from '@/features/login/Login.tsx';
import { Button, ensureSxObject } from '@arsnovasystems/ars-front-lib';
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import logo from '/icon-android-tinymdm-big-no-border.png';

/**
 * Logo component
 *
 * @param props                props of the component
 * @param props.sx             in case you have some sx to send to the container
 * @param props.disableOnClick If you want to avoid been able to click on logo
 * @returns                    JSX of the component
 */
const Logo = ({
  sx,
  disableOnClick = false,
}: {
  sx?: SxProps<Theme>;
  disableOnClick?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      direction={'row'}
      sx={(theme) => ({
        ...ensureSxObject(sx, theme),
        justifyContent: 'center',
      })}
    >
      <Button
        fullWidth={true}
        sx={{
          paddingTop: 0,
        }}
        onClick={() => {
          if (disableOnClick) return;
          void navigate('/');
        }}
        variant={'text'}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            img: {
              maxWidth: '40px',
            },
          }}
        >
          <img
            src={logo}
            alt='TinyMDM'
          />
        </Box>
        <Stack
          sx={{
            padding: 1,
            alignItems: 'flex-start',
          }}
        >
          <Typography variant={'h5'}>{t('ik.tinymdm')}</Typography>
          <Typography
            variant={'subtitle2'}
            sx={(theme) => ({
              letterSpacing: '2px',
              fontSize: '1rem',
              fontWeight: 600,
              color: theme.palette.secondary.contrastText,
              backgroundColor: SPECIFIC_PARTNER_BG_BANNER,
              textTransform: 'uppercase',
              paddingX: 1,
            })}
          >
            {t('Partner')}
          </Typography>
        </Stack>
      </Button>
    </Stack>
  );
};

export default Logo;
